import { StarGold } from '@/shared/icons/Star'

import { TReviewProps } from './types'

export const ReviewTypeF = ({ reviewsTitle, reviews }: TReviewProps) => {
  return (
    <div className="review-block">
      <div className="review-title" dangerouslySetInnerHTML={{ __html: reviewsTitle || '' }}></div>
      {reviews?.map((review) => {
        return (
          <div className="item-reviews" key={review.name}>
            <div className="star-container">
              <StarGold />
              <StarGold />
              <StarGold />
              <StarGold />
              <StarGold />
            </div>
            <div className="body-text">{review.description}</div>
            {review.name && (
              <div className="user-name" dangerouslySetInnerHTML={{ __html: review.name }}></div>
            )}
          </div>
        )
      })}
    </div>
  )
}
